import Cookies from 'js-cookie';

function googleTranslateElementInit() {
  // @ts-expect-error -- Google Translate defines this global when its script loads.
  new google.translate.TranslateElement(
    {
      pageLanguage: 'ru',
      // @ts-expect-error -- Google Translate defines this global when its script loads.
      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      autoDisplay: false,
      gaTrack: true,
      gaId: 'UA-32435293-24',
    },
    'google_translate_element'
  );
  console.log('google loaded');
}
window.googleTranslateElementInit = googleTranslateElementInit;

function getTopDomain() {
  const parts = location.hostname.split('.');
  return parts.slice(-2).join('.');
}

export function languageSelector() {
  // Load translate API only when either cookie with language is set
  // or we have language selected in anchor e.g. /#googtrans(pl)
  if (Cookies.get('googtrans') || window.location.hash.indexOf('googtrans(') !== -1) {
    const script = document.createElement('script');
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.setAttribute('defer', 'defer');
    document.body.appendChild(script);
  }

  const reset = document.querySelector('.language-selector__reset');
  if (reset) {
    reset.addEventListener('click', () => {
      Cookies.remove('googtrans');
      Cookies.remove('googtrans', { domain: '.' + getTopDomain() });
      window.location.reload();
    });
  }

  const languages = document.querySelectorAll<HTMLElement>('.language-selector__language');
  languages.forEach((language) => {
    language.addEventListener('click', () => {
      const code = language.dataset.code;
      if (!code) return;

      Cookies.set('googtrans', '/ru/' + code);
      Cookies.set('googtrans', '/ru/' + code, { domain: '.' + getTopDomain() });
      window.location.reload();
    });
  });
}
